<template>
  <lightbox id="globallightbox" ref="lightbox" :images="images"></lightbox>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "TheLightbox",
  computed: {
    ...mapGetters("lightbox", ["images", "isShow"])
  },
  watch: {
    isShow(newValue) {
      if (this.$_.isEmpty(newValue) === true) {
        return;
      }
      this.$refs.lightbox.show(newValue);
      this.$store.commit("lightbox/showed");
    }
    
  }
};
</script>